import { css } from '@emotion/react';
import { Footer } from './Footer';
import { useLabels } from '../providers/LabelsProvider';
import { colors, font, media, spacing } from '../config';
import brickMinifig from '../assets/brick_10_minifig.png';

const containerStyle = css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: spacing.size8,
  minHeight: 'calc(100vh - 320px)',
  padding: `${spacing.size12}px ${spacing.size6}px`,
  [media.medium]: {
    flexDirection: 'row',
    gap: spacing.size12,
    padding: `${spacing.size16}px ${spacing.size8}px`,
  },
  [media.large]: {
    gap: spacing.size16,
    minHeight: 'calc(100vh - 280px)',
  },
});

const imageStyle = css({
  width: 'min(32vw, 280px)',
  height: 'auto',
  [media.medium]: {
    width: 'min(30vw, 360px)',
  },
});

const contentStyle = css({
  maxWidth: 720,
  textAlign: 'left',
});

const accessGrantedStyle = css({
  margin: 0,
  fontSize: font.size.size2,
  fontWeight: font.weight.bold,
  lineHeight: font.lineHeight.s,
});

const headingStyle = css({
  margin: `${spacing.size5}px 0 ${spacing.size8}px`,
  color: colors.boldColors.lightBlue.lightBlue30,
  fontSize: 'clamp(2rem, 5vw, 5rem)',
  fontWeight: font.weight.bold,
  lineHeight: 1.08,
});

const bodyStyle = css({
  margin: 0,
  fontSize: font.size.size05,
  lineHeight: font.lineHeight.l,
  whiteSpace: 'pre-line',
});

const NoAssessmentsPage = () => {
  const {
    labels: { svy_no_assessments_header, svy_access_granted },
    richTextLabels: { svy_no_assessments_content },
  } = useLabels();

  return (
    <div>
      <main css={containerStyle}>
        <img src={brickMinifig} css={imageStyle} alt="" aria-hidden="true" />
        <div css={contentStyle}>
          <p css={accessGrantedStyle}>{svy_access_granted}</p>
          <h1 css={headingStyle}>{svy_no_assessments_header}</h1>
          <div
            css={bodyStyle}
            dangerouslySetInnerHTML={{ __html: svy_no_assessments_content }}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export { NoAssessmentsPage };
